var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowStepArrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 200,
    viewBox: "0 0 38 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M-136.7-1279.321h15.976l22.024,36.456-22.024,35.544H-136.7l22.319-35.544Z",
    transform: "translate(136.701 1279.321)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowStepArrowicon);
export default __webpack_public_path__ + "static/media/flowStepArrow.icon.5f8955e9dc7cd60022e9cf58a295048a.svg";
export { ForwardRef as ReactComponent };